export default "__VITE_ASSET__OF9t71bZ__"